export default __webpack_public_path__ + "static/media/Lit Fest Logo.a43b8d7e.png";